export const GENDER_OPTIONS = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
  { label: "Other", value: "O" },
];

export const ETHNICITY_OPTIONS = [
  { label: "African American / Black", value: "AFRICAN_AMERICAN_OR_BLACK" },
  { label: "American Indian / Alaska Native", value: "AMERICAN_INDIAN_OR_ALASKA_NATIVE" },
  { label: "Asian", value: "ASIAN" },
  { label: "Hispanic / Latino", value: "HISPANIC_OR_LATINO" },
  { label: "Native Hawaiian / Other Pacific Islander", value: "NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER" },
  { label: "White / Caucasian", value: "WHITE_OR_CAUCASIAN" },
  { label: "Other", value: "OTHER" },
];

export const ALZHEIMERS_STATUS_OPTIONS = [
  { label: "Alzheimer's", value: "ALZHEIMERS" },
  { label: "Mild Symptoms", value: "MILD_SYMPTOM" },
  { label: "Normal", value: "NORMAL" },
];

export const YES_NO_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const HEALTH_CONDITION_OPTIONS = [
  { label: "None", value: "none" },
  { label: "Alcohol Abuse", value: "alcohol_abuse" },
  { label: "Anemia", value: "anemia" },
  { label: "Aneurysm", value: "aneurysm" },
  { label: "Asthma", value: "asthma" },
  { label: "Autoimmune Disease", value: "autoimmune_disease" },
  { label: "Birth Defects", value: "birth_defects" },
  { label: "Bleeding Disorder", value: "bleeding_disorder" },
  { label: "Blood Clots", value: "blood_clots" },
  { label: "Breast Cancer", value: "breast_cancer" },
  { label: "Bronchitis (Recurring)", value: "bronchitis_recurring" },
  { label: "Cancer", value: "cancer" },
  { label: "Chicken Pox", value: "chicken_pox" },
  { label: "Colon Cancer", value: "colon_cancer" },
  { label: "Colon Polyps", value: "colon_polyps" },
  { label: "COPD (Lung Disease)", value: "copd" },
  { label: "Deep Vein Thrombosis", value: "deep_vein_thrombosis" },
  { label: "Dementia", value: "dementia" },
  { label: "Depression", value: "depression" },
  { label: "Diabetes", value: "diabetes" },
  { label: "Emphysema", value: "emphysema" },
  { label: "Heart Disease", value: "heart_disease" },
  { label: "Hepatitis", value: "hepatitis" },
  { label: "Herpes Zoster", value: "herpes_zoster" },
  { label: "High Cholesterol", value: "high_cholesterol" },
  { label: "Hives", value: "hives" },
  { label: "Hypertension (High Blood Pressure)", value: "hypertension" },
  { label: "Jaundice", value: "jaundice" },
  { label: "Kidney Disease", value: "kidney_disease" },
  { label: "Liver Disease", value: "liver_disease" },
  { label: "Measles", value: "measles" },
  { label: "Mental Illness", value: "mental_illness" },
  { label: "Mumps", value: "mumps" },
  { label: "Nervous Breakdown", value: "nervous_breakdown" },
  { label: "Osteoporosis", value: "osteoporosis" },
  { label: "Pneumonia (Recurring)", value: "pneumonia_recurring" },
  { label: "Prostate Cancer", value: "prostate_cancer" },
  { label: "Pulmonary Embolism", value: "pulmonary_embolism" },
  { label: "Rheumatic Fever", value: "rheumatic_fever" },
  { label: "Scarlet Fever", value: "scarlet_fever" },
  { label: "Seizures", value: "seizures" },
  { label: "Shingles", value: "shingles" },
  { label: "Stomach Ulcer", value: "stomach_ulcer" },
  { label: "Stroke", value: "stroke" },
  { label: "Thyroid Disease", value: "thyroid_disease" },
  { label: "Tuberculosis", value: "tuberculosis" },
  { label: "Valley Fever", value: "valley_fever" },
  { label: "Venereal Disease", value: "venereal_disease" }
];

export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
].map(state => ({ label: state, value: state }));
